import {mapProps} from 'recompose'

import compose from 'lodash/flowRight'
import * as React from 'react'

import withHook from '../hocs/withHook'
import type {BuildLineLayout, Enhancer} from '../types'
import {withContextAsProp} from '../utils/contexts'

export const BuildLineLayoutContext: React.Context<BuildLineLayout> = React.createContext(
  Object.freeze({}),
)
export const defaultBuildLineLayout: BuildLineLayout = {
  showBranch: true,
  showAgent: true,
  showDuration: true,
}

type OuterProps = BuildLineLayout & {
  children: React.ReactNode
}
type InnerProps = React.ProviderProps<BuildLineLayout>

export const BuildLineLayoutProvider = compose(
  mapProps(({children, ...value}: OuterProps) => ({
    children,
    value,
  })),
  withHook(({value}: InnerProps) => {
    const {
      showAgent = defaultBuildLineLayout.showAgent,
      showDuration = defaultBuildLineLayout.showDuration,
      showExactDuration = defaultBuildLineLayout.showExactDuration,
      showBranch = defaultBuildLineLayout.showBranch,
      showComment = defaultBuildLineLayout.showComment,
      showPath = defaultBuildLineLayout.showPath,
      showTags = defaultBuildLineLayout.showTags,
      artifactDependenciesMode = defaultBuildLineLayout.artifactDependenciesMode,
    } = value
    return {
      value: React.useMemo(
        () => ({
          showAgent,
          showDuration,
          showExactDuration,
          showBranch,
          showComment,
          showPath,
          showTags,
          artifactDependenciesMode,
        }),
        [
          showAgent,
          showDuration,
          showExactDuration,
          showBranch,
          showComment,
          showPath,
          showTags,
          artifactDependenciesMode,
        ],
      ),
    }
  }),
)(BuildLineLayoutContext)
export const withBuildLineLayout: Enhancer<any, any> = withContextAsProp(
  BuildLineLayoutContext,
  'buildLineLayout',
)
